import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const Partner = lazy(() => import('@/pages/partner'));
const PartnerList = lazy(() => import('@/pages/partner/join/PartnerList'));
const PartnerDetail = lazy(() => import('@/pages/partner/join/PartnerDetail'));
const PendingList = lazy(() => import('@/pages/partner/pending/PendingList'));
const PendingDetail = lazy(() => import('@/pages/partner/pending/PendingDetail'));
const RejectedList = lazy(() => import('@/pages/partner/rejected/RejectedList'));

// 파트너 관리 라우트
export const partnerRoutes: TypedRouteObject = {
	path: ROOTS.PARTNER,
	element: withSuspense(Partner),
	handle: {
		title: '파트너',
		subTitle: '파트너 등록 요청 및 가입 승인 관리',
	},
	children: [
		{
			index: true,
			element: <Navigate to={paths.partner.join.list.path} replace />,
		},
		// 가입 현황
		{
			path: paths.partner.join.list.path,
			element: withSuspense(PartnerList),
			handle: {
				title: '파트너',
				subTitle: '파트너 등록 요청 및 가입 승인 관리',
			},
		},
		{
			path: paths.partner.join.detail.path,
			element: withSuspense(PartnerDetail),
			handle: {
				isGoBack: true,
				title: '파트너',
				subTitle: '파트너 > 가입현황 > 상세정보',
			},
		},
		// 승인 대기
		{
			path: paths.partner.pending.list.path,
			element: withSuspense(PendingList),
			handle: {
				title: '파트너',
				subTitle: '파트너 가입 승인 대기 목록',
			},
		},
		{
			path: paths.partner.pending.detail.path,
			element: withSuspense(PendingDetail),
			handle: {
				isGoBack: true,
				title: '파트너',
				subTitle: '파트너 > 승인 대기 > 상세정보',
			},
		},
		// 반려 현황
		{
			path: paths.partner.rejected.list.path,
			element: withSuspense(RejectedList),
			handle: {
				title: '파트너',
				subTitle: '파트너 가입 반려 처리 내역',
			},
		},
	],
};
